import { render, staticRenderFns } from "./announceCampaign.vue?vue&type=template&id=4a40b9eb&scoped=true"
import script from "./announceCampaign.vue?vue&type=script&lang=js"
export * from "./announceCampaign.vue?vue&type=script&lang=js"
import style0 from "./announceCampaign.vue?vue&type=style&index=0&id=4a40b9eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a40b9eb",
  null
  
)

export default component.exports